import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, Button, Table, Col, Row, Label } from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { withNamespaces } from 'react-i18next';
import { handleCheckboxChange, handleQuantityChange } from '../helpers/po_helper';


const EnterQuantityForManualInventory = ({
  isOpen,
  toggle,
  onSubmit,
  item,
  t // from withNamespaces
}) => {
  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    return () => { setSelectedRows([]) }
  }, [toggle])

  const handleSubmit = () => {

      onSubmit(selectedRows);
      setSelectedRows([])
      toggle();
    
  };


  return (
    <Modal isOpen={isOpen} toggle={toggle} size="md">
      <ModalHeader toggle={toggle}>
        Enter Quantity
      </ModalHeader>
      <ModalBody>
        <AvForm onValidSubmit={handleSubmit}>
          <Col lg={12}>
            <Table bordered size="sm" responsive className="table table-sm">
              <thead>
                <tr>
                  <th>#</th>
                  <th>{t("Unit")}</th>
                  <th>{t("Quantity")}</th>
                  <th>{t("formula")}</th>
                </tr>
              </thead>
              <tbody>
                {item?.unit_levels && item.unit_levels.map((unitObj, index) => {
                  let prevUnit = index === 0 ? "NA" : item.unit_levels[index - 1].unit;
                  return (
                    <tr key={index}>
                      <td>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={selectedRows.some(row => row.index === index && row.isChecked)}
                            onChange={() => handleCheckboxChange(index, item, setSelectedRows, "")} />
                        </div>
                      </td>
                      <td onClick={() => handleCheckboxChange(index, item, setSelectedRows, "")}>
                        {unitObj.unit}
                      </td>
                      <td>
                        <AvField
                          type="number"
                          className="form-control"
                          style={{ width: "60px", height: "20px" }}
                          placeholder=""
                          name={unitObj.unit}
                          validate={{
                            required: { value: selectedRows.some(row => row.index === index && row.isChecked) },
                            // min: { value: selectedRows.some(row => row.index === index && row.isChecked) ? 1 : 0 }
                            pattern: { value: "^[0-9]+$", errorMessage: "No decimal values allowed" }, 
                          }}
                          errorMessage={t("Qty. can't be empty")}
                          disabled={!selectedRows.some(row => row.index === index && row.isChecked)}
                          // defaultValue="0"
                          value={selectedRows.find(row => row.index === index)?.value.toString() || ''}
                          onChange={(e) => {
                            const quantity = e.target.value;
                            handleQuantityChange(index, quantity, setSelectedRows);
                          }}
                        />
                      </td>
                      <td>
                        {index > 0
                          ? `1 ${prevUnit} = ${unitObj.value} ${unitObj.unit}`
                          : "NA"}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </Col>
          <Row className="mt-3">
            <Col lg={12}>
              <div className="text-center">
                <Button type="submit" color="primary">
                  {t("Add")}
                </Button>
              </div>
            </Col>
          </Row>
        </AvForm>
      </ModalBody>
    </Modal>
  );
};

export default withNamespaces()(EnterQuantityForManualInventory);